export default function columnTitle(columnNumber: number): string {
  let res: string = ""
  while (columnNumber !== 0) {
    columnNumber -= 1
    res = String.fromCharCode((columnNumber % 26) + 65) + res
    columnNumber = Math.floor(columnNumber / 26)
  }
  return res
}
